import React from 'react';
import { Typography } from '@lucid/lego';
import { SidebarIcon } from '@lucid/lego';
import styles from './QuickLinks.module.scss';
import sidebarData from '../../../../packages/lego/src/components/organisms/Sidebar/sidebar.json';

interface QuickLinksProps {
  theme: 'light' | 'dark';
}

const QuickLinks: React.FC<QuickLinksProps> = ({ theme }) => {
  const workspaces = sidebarData.data;

  return (
    <div className={styles.tocWrapper}>
      <Typography
        variant="headline"
        size="small"
        color="white"
        theme={theme}
        className={styles.tocTitle}
      >
        Quick Links
      </Typography>

      <div className={styles.workspacesGrid}>
        {workspaces.map((workspace) => (
          <div key={workspace.id} className={styles.workspaceColumn}>
            <div className={styles.workspaceHeader}>
              {workspace.icon && (
                <SidebarIcon
                  name={workspace.icon.name}
                  size={20}
                  color={theme === 'dark' ? 'white' : 'black'}
                />
              )}
              <Typography
                variant="body"
                size="large"
                color="primary-1"
                theme={theme}
                className={styles.workspaceTitle}
              >
                {workspace.label}
              </Typography>
            </div>
            <ul className={styles.childrenList}>
              {workspace.childrens?.map((child) => (
                <li key={child.id}>
                  <a href={child.path} className={styles.childLink}>
                    {child.icon && (
                      <SidebarIcon
                        name={child.icon.name}
                        size={16}
                        color={theme === 'dark' ? '#9CA3AF' : '#6B7280'}
                      />
                    )}
                    <Typography variant="body" size="medium" color="gray-4" theme={theme}>
                      {child.label}
                    </Typography>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickLinks;
